import repository from '@/repository'
import * as apiEnums from '@/constants/apiEnums'

export default {
  methods: {
    $dealerViewedCameraSettings(deviceId) {
      let payload = {
        objectId: deviceId,
        objectTypeId: apiEnums.DEVICE_TYPE,
        auditTypeId: apiEnums.CAMERA_SETTINGS_VIEWED,
      }
      repository.Audit.SendAudit(payload)
    },
    $singleCameraViewed(deviceId) {
      let payload = {
        objectId: deviceId,
        objectTypeId: apiEnums.DEVICE_TYPE,
        auditTypeId: apiEnums.SINGLE_CAMERA_VIEWED,
      }
      repository.Audit.SendAudit(payload)
    },
    $auditCustomerObject() {
      const customerId = this.$route.meta.internalOnly
        ? parseInt(this.$route.params.customerId)
        : parseInt(this.$route.params.id)
      return this.$store.getters['Customers/currentCustomer'](customerId)
    },
    $auditCustomerId() {
      const security = this.$store.state.Security
      if (security.user.isDealerUser) {
        const customerObject = this.$auditCustomerObject()
        if (customerObject && customerObject.customerId) {
          return customerObject.customerId
        }
        if (security.dealerCustomerId) {
          return security.dealerCustomerId
        }
      }
      return security.user.customerId
    },
    $cameraSettingsChanged(deviceId, eventPayload, cameraObject = {}) {
      const payload = {
        CustomerId: this.$auditCustomerId(),
        LocationId: cameraObject.locationId,
        LocationName: cameraObject.location,
        DeviceId: deviceId,
        DeviceName: cameraObject.deviceName,
        EntityType: apiEnums.AUDIT_ENTITY_TYPE.CAMERA,
        EntityActionType: apiEnums.AUDIT_ENTITY_ACTION_TYPE.ADJUST_SETTINGS,
        EntityId: deviceId,
        EntityName: cameraObject.deviceName,
        Remarks: JSON.stringify(eventPayload),
      }

      repository.CustomerActivity.Create(payload)
    },

    $cameraViewLive(deviceId, eventPayload, cameraObject = {}) {
      const payload = {
        CustomerId: this.$auditCustomerId(),
        LocationId: cameraObject.locationId,
        LocationName: cameraObject.location,
        DeviceId: deviceId,
        DeviceName: cameraObject.deviceName,
        EntityType: apiEnums.AUDIT_ENTITY_TYPE.CAMERA,
        EntityActionType: apiEnums.AUDIT_ENTITY_ACTION_TYPE.VIEW_LIVE_CAMERA,
        EntityId: deviceId,
        EntityName: cameraObject.deviceName,
        Remarks: JSON.stringify(eventPayload),
      }

      repository.CustomerActivity.Create(payload)
    },

    $cameraViewPlayback(deviceId, eventPayload, cameraObject = {}) {
      const payload = {
        CustomerId: this.$auditCustomerId(),
        LocationId: cameraObject.locationId,
        LocationName: cameraObject.location,
        DeviceId: deviceId,
        DeviceName: cameraObject.deviceName,
        EntityType: apiEnums.AUDIT_ENTITY_TYPE.CAMERA,
        EntityActionType: apiEnums.AUDIT_ENTITY_ACTION_TYPE.PLAYBACK_VIDEO,
        EntityId: deviceId,
        EntityName: cameraObject.deviceName,
        Remarks: JSON.stringify(eventPayload),
      }

      repository.CustomerActivity.Create(payload)
    },

    $cameraExportClip(deviceId, eventPayload, cameraObject = {}) {
      const payload = {
        CustomerId: this.$auditCustomerId(),
        LocationId: cameraObject.locationId,
        LocationName: cameraObject.location,
        DeviceId: deviceId,
        DeviceName: cameraObject.deviceName,
        EntityType: apiEnums.AUDIT_ENTITY_TYPE.CAMERA,
        EntityActionType: apiEnums.AUDIT_ENTITY_ACTION_TYPE.EXPORT_CLIP,
        EntityId: deviceId,
        EntityName: cameraObject.deviceName,
        Remarks: JSON.stringify(eventPayload),
      }

      repository.CustomerActivity.Create(payload)
    },

    $cameraCreateScreenshot(deviceId, eventPayload, cameraObject = {}) {
      const payload = {
        CustomerId: this.$auditCustomerId(),
        LocationId: cameraObject.locationId,
        LocationName: cameraObject.location,
        DeviceId: deviceId,
        DeviceName: cameraObject.deviceName,
        EntityType: apiEnums.AUDIT_ENTITY_TYPE.CAMERA,
        EntityActionType: apiEnums.AUDIT_ENTITY_ACTION_TYPE.CREATE_SCREENSHOT,
        EntityId: deviceId,
        EntityName: cameraObject.deviceName,
        Remarks: JSON.stringify(eventPayload),
      }

      repository.CustomerActivity.Create(payload)
    },
  },
}
